

































import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";

/*
    * Method for pupulate text input control - STARTS
    1. attach                  - Specifies which DOM element that this component should detach to.String can be any valid querySelector and Object can be any valid Node.
    2. title                   - A string that is shown on top of the table. This is optional.
    3. tooltip                 - The v-tooltip component is useful for conveying information when a user hovers over an element.
    4. tooltipList             - The v-tooltip component is useful for conveying all field information when a user hovers over an element.
    5. tooltipOption           - inital loading tooltip dialog hide and only enabled in the tooltip mouseover.
*/

/*
    * Component's properties and events
*/
@Component({
    components: { }
})

export default class TooltipsComponent extends Vue {
    /*
        * Component's props
    */
    @Prop() readonly attach!: any;
    @Prop() readonly title!: any;
    @Prop() readonly tooltip!: any;
    @Prop() readonly tooltipList!: any;
    @Prop() readonly tooltipOption!: any;

    /*
        * Component's variables
    */
    private showMore: boolean = false;
    
    /*
        * Define methods under the `methods` object
        * _tpShowMoreTooltip    - Method for show all tooltip
        * _tpRemoveMoreTooltip  - Method for remove all tooltip
    */
    /*
            * Method for show all tooltip
        */
    _tpShowMoreTooltip() {
        this.showMore = true;
    }

    /*
        * Method for remove all tooltip
    */
    _tpRemoveMoreTooltip() {
        this.showMore = false;
    }    
}
